const setStyleSlider = (el, index, isReset) => {
    if(isReset){
        el[index].style.transform = 'scale(1)'
        el[index].style.opacity = 0
        el[index].style.visibility = 'hidden'
    }else{
        el[index].style.transform = 'scale(1.1)'
        el[index].style.opacity = 1
        el[index].style.visibility = 'initial'
    }
}

const setStyleCaption = (el, index, isReset) => {
    if(isReset) {
        el[index].style.visibility = 'hidden'
        el[index].style.top = '-50px'
        el[index].style.transition = "none"
        el[index].style.opacity = 0
    }else{
        el[index].style.visibility = 'initial'
        el[index].style.top = 0
        el[index].style.transition = "all 2s ease"
        el[index].style.opacity = 1
    }
}

const setStyleBanner = (el, index, isReset) => {
    if (isReset){
        el[index].style.visibility = 'hidden'
        el[index].style.top = '100px'
        el[index].style.transition = "none"
        el[index].style.opacity = 0
    }else{
        el[index].style.visibility = 'initial'
        el[index].style.top = 0
        el[index].style.transition = "all 2s ease"
        el[index].style.opacity = 1
    }
}

const setStyleButton = (el, index, isReset) => {
    if (isReset){
        el[index].style.display = 'none'
        el[index].style.opacity = 0
    }else{
        el[index].style.display = 'block'
        el[index].style.opacity = 1
    }
}






export {setStyleSlider, setStyleCaption, setStyleBanner, setStyleButton}